var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":'التقارير',"description":' طلبات البيع حسب الفاتورة.'}}),_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"العميل","plaseholder":"اختر عميل","show":'name',"refrance":'id',"value":_vm.params.customer_id,"values":_vm.$database.customers},model:{value:(_vm.params.customer_id),callback:function ($$v) {_vm.$set(_vm.params, "customer_id", $$v)},expression:"params.customer_id"}}),_c('dateFilter',{staticClass:"col-md-3"}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المستخدم","plaseholder":"اختر مستخدم","show":'name',"refrance":'id',"value":_vm.params.user_id,"values":this.users},model:{value:(_vm.params.user_id),callback:function ($$v) {_vm.$set(_vm.params, "user_id", $$v)},expression:"params.user_id"}}),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("الحالة")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("اختر حالة")]),_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$t('orders.form.draft')))]),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('orders.form.call1')))]),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('orders.form.call2')))]),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('orders.form.call3')))]),_c('option',{attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$t('orders.form.Certain')))]),_c('option',{attrs:{"value":"5"}},[_vm._v(_vm._s(_vm.$t('orders.form.readyForShipping')))]),_c('option',{attrs:{"value":"6"}},[_vm._v(_vm._s(_vm.$t('orders.form.shipped')))]),_c('option',{attrs:{"value":"7"}},[_vm._v(_vm._s(_vm.$t('orders.form.returnd')))]),_c('option',{attrs:{"value":"8"}},[_vm._v(_vm._s(_vm.$t('orders.form.returnedToOrigen')))]),_c('option',{attrs:{"value":"9"}},[_vm._v(_vm._s(_vm.$t('orders.form.rejected')))]),_c('option',{attrs:{"value":"10"}},[_vm._v(_vm._s(_vm.$t('orders.form.canceled')))])])])]),_c('actionButtons',{staticClass:"col-md-3"})],1)])]),_c('div',{attrs:{"id":"reportShow"}},[_c('reportHeader',{attrs:{"title":"  تقرير طلبات المبيعات حسب الفاتورة","details":[
            {title: 'اسم العميل', value : _vm.customerName },
            {title: 'اسم المستخدم', value : _vm.userName } ]}}),_c('reportTable',{attrs:{"emptyTableText":'لايوجد بيانات حاليا',"emptyTableSubText":'جرب اضافة البعض واعد المحاولة',"cloumns":[
            { column: 'code', link: '/invoices', title: 'الكود', type:'reportMainLink', sort: true},
            {
              column: 'date',
              title: 'التاريخ',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'customer',
              title: 'العميل',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'user',
              title: 'المستخدم',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'status',
              title: _vm.$t('orders.situation') ,
              type: 'status',
              sort: true ,  
              values: [
                {title: _vm.$t('orders.draft'), value: 0, color: 'dark'},
                { title: _vm.$t('orders.call1'), value: 1, color: 'dark' },
                { title: _vm.$t('orders.call2'), value: 2, color: 'dark' },
                { title: _vm.$t('orders.call3'), value: 3, color: 'dark' },
                { title: _vm.$t('orders.Certain'), value: 4, color: 'success' },
                { title: _vm.$t('orders.readyForShipping'), value: 5, color: 'success' },
                { title: _vm.$t('orders.shipped'), value: 6, color: 'success' },
                { title: _vm.$t('orders.returnd'), value: 7, color: 'danger'},
                { title: _vm.$t('orders.returnedToOrigen'), value: 8 , color: 'danger'},
                { title: _vm.$t('orders.rejected'), value: 9, color: 'danger' },
                { title: _vm.$t('orders.canceled'), value: 10, color: 'danger' } ]
            },
            {
              column: 'subtotal',
              title: 'الأجمالي',
              type: 'text',
              sort: true,
            },
            {
              column: 'edit',
              title: 'تعديل',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'delivery',
              title: 'رسوم الشحن',
              type: 'text',
              sort: true,
            },
            {
              column: 'tax',
              title: 'الضرائب',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'discount',
              title: 'خصم',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'total',
              title: 'المجموع',
              type: 'text',
              sort: true,
            } ],"footer":[
            { colspan: 1, value: 'المجموع' },
            { colspan: 4, value: _vm.invoicesCount, supData: true },
            { colspan: 1, value: _vm.subtotal },
            {
              colspan: 1,
              value: _vm.edit,
              supData: true,
            },
            { colspan: 1, value: _vm.delivery },
            {
              colspan: 1,
              value: _vm.tax,
              supData: true,
            },
            {
              colspan: 1,
              value: _vm.discount,
              supData: true,
            },
            { colspan: 1, value: _vm.total } ]}})],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_c('i',{staticClass:"fal fa-edit"}),_vm._v(" خيارات التقرير ")])])}]

export { render, staticRenderFns }